import { TransactionItem, type TransactionListItem } from './TransactionItem'

interface PendingTransactionItemProps {
  transaction: TransactionListItem
}

export function PendingTransactionItem({ transaction }: PendingTransactionItemProps) {
  return <TransactionItem transaction={transaction} variant="pending" />
}
